export const SHOW_MENU_WHITELIST: string[] = [
  /** about us **/
  '/about-us',
  '/par-mums',
  '/apie-mus',
  '/meist',

  /** company history **/
  '/company-history',
  '/uznemuma-vesture',
  '/imones-istorija',
  '/ettevotte-ajalugu'
]
